<script>
// template 不方便递归，用jsx生成菜单
export default {
  name: "md-menu",
  props: {
    menuData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      collapse: false,
    };
  },
  // Menu.vue
  computed: {
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      // 修改此处 ↓
      return path || (this.menuData && this.menuData[0] ? this.menuData[0].code : '')
    },
  },
  methods: {
    createMenuItem(menu) {
      return menu.map(({ code, name, children, iconClass }) =>
        children.length === 0 ? (
          <el-menu-item index={code}>
            <i class={iconClass}></i>
            <span class="title">{name}</span>
          </el-menu-item>
        ) : (
          <el-submenu index={code}>
            <template slot="title">
              <div>
                <i class={iconClass}></i>
                <span class="title">{name}</span>
              </div>
            </template>
            {this.createMenuItem(children)}
          </el-submenu>
        )
      );
    },
  },
  render() {
    return (
      <el-menu
        style="height:100%"
        default-active="activeMenu"
        background-color="transparent"
        text-color="#c1cbd8"
        opacity='1'
        active-text-color="#24DEFF"
        router
      >
        {this.createMenuItem(this.menuData)}
      </el-menu >
    );
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-menu-item {
  position: relative;
  transition: all 0.3s;

  &.is-active {
    background: linear-gradient(90deg, rgba(81, 191, 255, 0.212) 0%, rgba(81, 190, 255, 0) 100%) !important;
    color: rgb(36, 222, 255) !important;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      background: #24deff44;
    }
  }
}


.title {
  font-size: 13px;
  margin-left: 8px;
}
</style>
